(() => {
  if (window.bokumoGloboCartInstalled) return;
  window.bokumoGloboCartInstalled = true;
  let busy = false;

  async function add(form, button) {
    if (busy || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;
    const notification = document.querySelector('cart-notification');
    let message = form.querySelector('[data-bokumo-cart-message]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.bokumoCartMessage = '';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      form.append(message);
    }
    message.textContent = '';
    if (!notification || typeof notification.renderContents !== 'function') {
      message.textContent = 'カート通知を読み込めませんでした。ページを再読み込みしてください。';
      return;
    }
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    notification.setActiveElement(button);
    let added = false;
    try {
      const data = new FormData(form);
      data.set('sections', notification.getSectionsToRender().map(section => section.id).join(','));
      data.set('sections_url', window.location.pathname);
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        message.textContent = typeof result.description === 'string' ? result.description : '商品を追加できませんでした。在庫や数量をご確認ください。';
        return;
      }
      added = true;
      notification.renderContents(result);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bokumo-globo-cart', productVariantId: data.get('id'), cartData: result,
        })).catch(() => {});
      }
    } catch (error) {
      message.textContent = added
        ? '商品をカートに追加しました。通知を表示できないため、カートから内容をご確認ください。'
        : '追加結果を確認できませんでした。再度押す前にカートの内容をご確認ください。';
    } finally {
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  // Capture before Globo's delegated click handler, so one action adds only once.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.spf-product__form-btn-addtocart');
    const form = button?.closest('form.spf-product__form');
    if (!form || !form.closest('#gf-products')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void add(form, button);
  }, true);

  // Handles keyboard submission and cards inserted after filtering/pagination.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form.spf-product__form') || !form.closest('#gf-products')) return;
    const button = form.querySelector('.spf-product__form-btn-addtocart');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void add(form, button);
  }, true);
})();
